import { filter } from 'lodash';

export function useVuetifyEffects() {
  const removeVChipItem = (arr, elementToRemove) => {
    return filter(arr, el => el !== elementToRemove);
  };

  return { removeVChipItem };
}
